Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "TextButton2304829319",
  {"root":"TextButton2304829319--root","PrimaryColor":"color-8","SecondaryColor":"color-5","LinkColor":"color-5","DisabledColor":"color-3","DefaultFont":"\"{theme: 'Body-M', size: '16px', lineHeight: '1.5em'}\"","MobileDefaultFont":"\"{theme: 'Body-M', size: '14px', lineHeight: '1.44em'}\"","MainTextColor":"--overidable","MainTextFont":"--overridable","PrimaryTextColor":"\"color(fallback(--overidable, color-8))\"","SecondaryTextColor":"\"color(fallback(--overidable, color-5))\"","LinkTextColor":"\"color(fallback(--overidable, color-5))\""},
  "",
  7,
  "TextButton2304829319"
);

